import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./pin-gateway-positioning.module.scss";
import PinnedListHeader from "../pinned-list-header";
import VelavuNotice from "../../../../elements/velavu-notice/velavu-notice";
import VelavuButton from "../../../../elements/velavu-button";
import PinnedList from "../pinned-list";
import VelavuItemIcon from "../../../../elements/velavu-item-icon";

export interface PinGatewayPositioningProps {
	deviceID: string;
	deviceModel: string | undefined;
	onClose?: () => void;
	onNext?: () => void;
	isLoading?: boolean;
	disableNext?: boolean;
}

export default function PinGatewayPositioning(
	props: PinGatewayPositioningProps,
) {
	const { t } = useTranslation();

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.pin_gateway.positioning.header")}
				onClose={props.onClose}
			/>

			<div className={styles.content}>
				<div className={styles.deviceDetails}>
					<VelavuItemIcon data={{ model: props.deviceModel }} />

					<span className={styles.deviceLabel}>{props.deviceID}</span>
				</div>

				<VelavuNotice type="info">
					{t("dashboard.pin_gateway.positioning.instructions")}
				</VelavuNotice>

				<div className={styles.buttonWrapper}>
					<VelavuButton
						label={t(
							"dashboard.pin_gateway.positioning.pin_button",
						)}
						onClick={props.onNext}
						disabled={props.disableNext || props.isLoading}
						loadingIndicator={props.isLoading}
						fullWidth
					/>
				</div>
			</div>
		</PinnedList>
	);
}
